
import { Link } from "react-router-dom"
import { Badge } from "../../components/ui/badge"
import { Button } from "../../components/ui/button"
import { Calendar, Award, Building2, Users, TrendingUp, ChevronRight } from "lucide-react"
import SEO from "../SEO"

export default function HistoryPage() {
 const historySchema = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": "https://pranaamhospitals.com/about/history",
    "url": "https://pranaamhospitals.com/about/history",
    "name": "History of Pranaam Hospitals",
    "description": "The journey of Pranaam Hospitals through key milestones, awards, expansions, and achievements from inception to present.",
    "inLanguage": "en"
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://pranaamhospitals.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "About",
        "item": "https://pranaamhospitals.com/about"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "History",
        "item": "https://pranaamhospitals.com/about/history"
      }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "Pranaam Hospitals",
    "url": "https://pranaamhospitals.com/",
    "logo": "https://pranaamhospitals.com/wp-content/uploads/2025/logo.png",
    "description": "Pranaam Hospitals delivers world-class healthcare with compassion, innovation, and integrity across Hyderabad and surrounding regions.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "emergency",
        "telephone": "+91-98485-98285",
        "availableLanguage": ["English", "Telugu", "Hindi"]
      },
      {
        "@type": "ContactPoint",
        "contactType": "appointments",
        "telephone": "+91-99660-60000",
        "availableLanguage": ["English", "Telugu", "Hindi"]
      }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://pranaamhospitals.com/about/history"
    },
    "headline": "History of Pranaam Hospitals – Key Milestones & Achievements",
    "description": "Explore the timeline of Pranaam Hospitals’ growth, awards, expansions, and contributions to healthcare excellence in Hyderabad.",
    "author": {
      "@type": "Organization",
      "name": "Pranaam Hospitals"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Pranaam Hospitals",
      "logo": {
        "@type": "ImageObject",
        "url": "https://pranaamhospitals.com/wp-content/uploads/2025/logo.png"
      }
    },
    "datePublished": "2015-01-01",
    "dateModified": "2025-01-01",
    "keywords": [
      "Pranaam Hospitals history",
      "Pranaam Hospitals milestones",
      "hospital awards Hyderabad",
      "healthcare timeline Telangana"
    ],
    "articleSection": [
      "History",
      "Milestones",
      "Awards",
      "Growth Timeline"
    ]
  }
];

  const milestones = [
    {
      year: "2024",
      title: "Expanding Innovation",
      description:
        "Set to make in India provision of hundreds of hysteroscopic visualization with AMTZ, AP any time clinic and Bagru clinic.",
      achievements: ["Partnership with AMTZ", "Any Time Clinic Launch", "Bagru Clinic Opening"],
    },
    {
      year: "2023",
      title: "National Recognition",
      description:
        "Hyderabad's best hospital 13th National best Multispeciality in Times of India survey plus other Awards.",
      achievements: ["13th National Best Hospital", "Times of India Recognition", "Multiple Awards"],
    },
    {
      year: "2022",
      title: "Quality Reaffirmed",
      description: "Reaccreditation of NABH Super 4th Edition plus other Awards.",
      achievements: ["NABH Super 4th Edition", "Quality Standards", "Service Excellence"],
    },
    {
      year: "2021",
      title: "Pediatric Excellence",
      description: "Times of India Survey 3rd Best Pediatric Hospital in Hyderabad City plus other Awards.",
      achievements: ["3rd Best Pediatric Hospital", "Specialized Care", "Community Recognition"],
    },
    {
      year: "2020",
      title: "Capacity Expansion",
      description: "Expanded facility to 125 beds.",
      achievements: ["125 Beds", "Enhanced Infrastructure", "Advanced Equipment"],
    },
    {
      year: "2019",
      title: "New Location",
      description: "Launched Isnapur Medical Center.",
      achievements: ["Isnapur Branch", "Community Expansion", "Accessible Healthcare"],
    },
    {
      year: "2018",
      title: "Specialized Recognition",
      description: "Times of India Healthcare Excellence award best in Gynecological care Hospital.",
      achievements: ["Best Gynecological Care", "Healthcare Excellence", "Women's Health"],
    },
    {
      year: "2017",
      title: "Top Ranking",
      description: "Ranked #1 best hospital in TOI survey.",
      achievements: ["#1 Best Hospital", "Patient Satisfaction", "Quality Care"],
    },
    {
      year: "2016",
      title: "Wellness Focus",
      description: "Opened Pranaam Wellness Centre at Nallagandla, ranked #1 best hospital in TOI survey.",
      achievements: ["Wellness Centre", "#1 Ranking", "Holistic Care"],
    },
    {
      year: "2015",
      title: "Gold Standard Recognition",
      description: "Awarded NABH Gold Standard & Ranked #1 best hospital in TOI survey.",
      achievements: ["NABH Gold Standard", "#1 Best Hospital", "Excellence in Care"],
    },
    {
      year: "2014",
      title: "Quality Certification",
      description: "Awarded ISO 9001 certification.",
      achievements: ["ISO 9001", "Quality Management", "International Standards"],
    },
    {
      year: "2008",
      title: "First Expansion",
      description: "Expanded to 60 beds.",
      achievements: ["60 Beds", "Growing Capacity", "Enhanced Services"],
    },
    {
      year: "2002",
      title: "Foundation",
      description: "Incorporated with 20 beds.",
      achievements: ["20 Beds", "Founding Vision", "Beginning of Excellence"],
    },
  ]

  return (
    <>
    <SEO
  title="History of Pranaam Hospitals | Our Journey of Healthcare Excellence in Hyderabad"
  description="Explore the history of Pranaam Hospitals and its journey of growth, milestones, awards, and commitment to delivering trusted healthcare excellence in Hyderabad."
  canonical="https://pranaamhospitals.com/about/history"
  robots="index, follow"
  author="Pranaam Hospitals"
  publisher="Pranaam Hospitals"
  keywords="Pranaam Hospitals history, hospital journey Hyderabad, healthcare milestones Pranaam Hospitals, NABH hospital history Hyderabad, trusted hospital legacy Hyderabad"
  schema={historySchema}
/>



    <div className="min-h-screen bg-white">
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-primary/10 to-primary/5 py-16 md:py-24">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto text-center">
              <Badge className="mb-4 px-3 py-1">Our Journey</Badge>
              <h1 className="mb-6 text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
                24 Years of <span className="text-primary">Healthcare Excellence</span>
              </h1>
              <p className="mb-8 text-lg text-gray-700 max-w-3xl mx-auto">
                Since our inception 22 years ago, we have provided nothing short of sheer excellence in various medical
                and surgical disciplines, hitting several milestones along the way. Yet, we haven't rested on our
                laurels and continue to strive in providing the quality healthcare services for many more decades to
                come, making Pranaam Hospitals the sole choice for all your healthcare needs.
              </p>
              <div className="flex flex-wrap justify-center gap-4 mt-8">
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <Calendar className="w-4 h-4 mr-2" />
                  Established 2002
                </Badge>
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <Award className="w-4 h-4 mr-2" />
                  Multiple Accolades
                </Badge>
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <Building2 className="w-4 h-4 mr-2" />4 Locations
                </Badge>
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <Users className="w-4 h-4 mr-2" />
                  125+ Beds
                </Badge>
              </div>
            </div>
          </div>
        </section>

        {/* Journey Overview */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <h2 className="mb-4 text-3xl font-bold md:text-4xl">A Legacy of Compassionate Care</h2>
              <p className="text-lg text-muted-foreground">
                From a modest 20-bed facility to a multi-specialty healthcare institution with 125 beds across 4
                locations, our journey reflects our unwavering commitment to healthcare excellence and patient-centric
                care.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
              <div className="text-center p-6 rounded-lg border border-gray-200 bg-white hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
                  <TrendingUp className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-3xl font-bold text-primary mb-2">22+</h3>
                <p className="text-gray-600">Years of Excellence</p>
              </div>
              <div className="text-center p-6 rounded-lg border border-gray-200 bg-white hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
                  <Award className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-3xl font-bold text-primary mb-2">50+</h3>
                <p className="text-gray-600">Awards & Recognitions</p>
              </div>
              <div className="text-center p-6 rounded-lg border border-gray-200 bg-white hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
                  <Users className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-3xl font-bold text-primary mb-2">500K+</h3>
                <p className="text-gray-600">Patients Served</p>
              </div>
            </div>
          </div>
        </section>

        {/* Timeline Section */}
        <section className="py-16 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <Badge className="mb-2">Our Milestones</Badge>
              <h2 className="mb-4 text-3xl font-bold md:text-4xl">Journey Through the Years</h2>
              <p className="text-gray-700">
                Every milestone marks our dedication to advancing healthcare and serving our community with excellence.
              </p>
            </div>

            <div className="relative max-w-5xl mx-auto">
              {/* Timeline line */}
              <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-primary/20 md:left-1/2 md:-ml-0.5"></div>

              {/* Timeline items */}
              <div className="space-y-12">
                {milestones.map((milestone, index) => (
                  <div key={milestone.year} className="relative">
                    {/* Timeline dot */}
                    <div className="absolute left-0 flex items-center justify-center md:left-1/2 md:-ml-4">
                      <div className="z-10 flex items-center justify-center w-8 h-8 text-white rounded-full bg-primary shadow-md">
                        <span className="text-xs font-medium">{index + 1}</span>
                      </div>
                    </div>

                    {/* Content */}
                    <div
                      className={`relative flex flex-col items-start ${
                        index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                      } md:items-center`}
                    >
                      {/* Spacer for alternating layout */}
                      <div className="hidden w-full md:block md:w-1/2"></div>

                      {/* Card */}
                      <div
                        className={`flex flex-col items-start w-full pl-12 md:w-1/2 ${
                          index % 2 === 0 ? "md:pl-8" : "md:pr-8 md:pl-0 md:items-end md:text-right"
                        }`}
                      >
                        <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow w-full">
                          <span className="inline-block px-3 py-1 mb-3 text-sm font-medium rounded-full bg-primary/10 text-primary">
                            {milestone.year}
                          </span>
                          <h3 className="mb-2 text-xl font-bold">{milestone.title}</h3>
                          <p className="text-gray-700 mb-4">{milestone.description}</p>
                          <div className="flex flex-wrap gap-2">
                            {milestone.achievements.map((achievement) => (
                              <Badge key={achievement} variant="outline" className="text-xs">
                                {achievement}
                              </Badge>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Key Achievements */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <Badge className="mb-2">Achievements</Badge>
              <h2 className="mb-4 text-3xl font-bold md:text-4xl">Our Proudest Moments</h2>
              <p className="text-gray-700">
                Recognition that validates our commitment to healthcare excellence and patient satisfaction.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white border border-gray-200 rounded-lg p-6 text-center hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                  <Award className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-bold mb-2">NABH Accreditation</h3>
                <p className="text-sm text-gray-700">Gold Standard 4th Edition</p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6 text-center hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                  <Award className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-bold mb-2">#1 Best Hospital</h3>
                <p className="text-sm text-gray-700">Multiple Years - TOI Survey</p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6 text-center hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                  <Award className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-bold mb-2">ISO 9001 Certified</h3>
                <p className="text-sm text-gray-700">Quality Management System</p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6 text-center hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                  <Award className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-bold mb-2">13th National Best</h3>
                <p className="text-sm text-gray-700">Multispeciality Hospital</p>
              </div>
            </div>
          </div>
        </section>

        {/* Vision for Future */}
        <section className="py-16 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
              <div>
                <Badge className="mb-4">Looking Ahead</Badge>
                <h2 className="mb-6 text-3xl font-bold md:text-4xl">Our Vision for the Future</h2>
                <p className="text-lg text-gray-700 mb-6">
                  As we continue our journey, we remain committed to expanding our services, adopting cutting-edge
                  medical technologies, and maintaining the highest standards of patient care that have defined us for
                  over two decades.
                </p>
                <p className="text-gray-700 mb-8">
                  Our focus is on innovation, accessibility, and compassionate care—ensuring that Pranaam Hospitals
                  continues to be the preferred choice for healthcare needs for generations to come.
                </p>
                <div className="flex flex-wrap gap-4">
                  <Button asChild>
                    <Link to="/about">
                      Learn More About Us
                      <ChevronRight className="w-4 h-4 ml-2" />
                    </Link>
                  </Button>
                  <Button variant="outline" asChild>
                    <Link to="/locations">View Our Locations</Link>
                  </Button>
                </div>
              </div>
              <div className="relative h-96 rounded-lg overflow-hidden shadow-xl">
                <img
                  src="https://pranaamhospitals.com/wp-content/uploads/2026/05/HealthcareSpectrum.png"
                  alt="Pranaam Hospitals - Future Vision"
                  className="object-cover w-full h-full"
                  width={800}
                  height={600}
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto bg-gradient-to-r from-primary to-primary/90 rounded-lg shadow-xl p-8 md:p-12 text-white text-center">
              <h2 className="mb-4 text-3xl font-bold md:text-4xl">Be Part of Our Story</h2>
              <p className="mb-8 text-lg opacity-90">
                Join thousands of patients who have trusted Pranaam Hospitals for their healthcare needs over the past
                22 years.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Button size="lg" variant="secondary" asChild>
                    <a
                href="/book-now"
                rel="noopener noreferrer"
              >
                    <Calendar className="w-5 h-5 mr-2" />
                    Book an Appointment
                  </a>
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="bg-white/10 border-white text-white hover:bg-white hover:text-primary"
                  asChild
                >
                  <Link to="/contact">Contact Us</Link>
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
    </>
  )
}
